import React from "react";
import { Row, Col } from "antd";
import {
  IconPhone,
  IconMail,
  IconMapPin,
  IconBrandFacebook,
  IconBrandTiktok,
  IconBrandYoutube,
  IconBrandInstagram,
} from "@tabler/icons-react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <Row gutter={[64, 32]}>
          <Col xs={24} sm={24} md={8}>
            <div className="footer-section">
              <h3>About Us</h3>
              <p>
                Sky Auto is an auto loan lender focused on a professional,
                friendly and respectful customer experience. Our management team
                and staff has over 100 years of combined lending experience.{" "}
                <br />
                <br />
                We guarantee you a knowledgeable, friendly and professional
                experience with great attention to your financing needs. <br />
                <br />
                Our team can communicate with you in either English or Spanish.
              </p>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul className="footer-links">
                <li>
                  <a href="https://skyautofinance.com/about-us/">About Us</a>
                </li>
                <li>
                  <a href="https://skyautofinance.com/how-it-works/">
                    How It Works
                  </a>
                </li>
                <li>
                  <a href="https://skyautofinance.com/faq/">FAQ</a>
                </li>
                <li>
                  <a href="https://skyautofinance.com/contact-us/">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="footer-section">
              <h3>Contact Us</h3>
              <ul className="contact-info">
                <li>
                  <IconPhone size={18} />
                  <a href="tel:+19548369299">954-836-9299</a>
                </li>
                <li>
                  <IconMail size={18} />
                  <a href="mailto:info@skyautofinance.com">
                    info@skyautofinance.com
                  </a>
                </li>
              </ul>

              <div className="social-icons">
                <a
                  href="https://www.facebook.com/skyautofinanceLLC"
                  aria-label="Facebook"
                >
                  <IconBrandFacebook size={24} />
                </a>

                <a
                  href="https://www.instagram.com/skyautofinance/?igsh=MXFuc2w0MnphZ2Jzag%3D%3D"
                  aria-label="Instagram"
                >
                  <IconBrandInstagram size={24} />
                </a>
                <a
                  href="https://www.youtube.com/@SkyAutofinance"
                  aria-label="YouTube"
                >
                  <IconBrandYoutube size={24} />
                </a>
                <a
                  href="https://www.tiktok.com/@skyautofinance?lang=es"
                  aria-label="TikTok"
                >
                  <IconBrandTiktok size={24} />
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="copyright">
        <p>
          &copy; {new Date().getFullYear()} Sky Auto Finance including Web
          Design, Logos and Content | Car Title Loans Made Easy | All Rights
          Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
